"use client";
import {useEffect} from "react";
import {Button} from "@/app/_components";
import {confJson} from "@/app/config/confJson";
import GameTrack from "@/Core/GameTrack";
import styles from "./Step1_2.module.css";

type Step2Props = {
    target?: () => HTMLElement | null;
    currentStep?: number;
    currIndex: number;
    onNext?: (idx: number) => void;
}

const buttonStyle: React.CSSProperties = {
    color: "#fff",
    width: "3.7rem",
    height: "1.1rem",
    fontWeight: 900,
    fontSize: ".5rem"
}

const Step2: React.FC<Step2Props> = props => {
    const { target, currentStep, currIndex, onNext } = props;

    const _targetStyle = target?.()?.getBoundingClientRect();
    if (!_targetStyle) return;

    const { x, y, width, height } = _targetStyle;
    const wrapperStyle: React.CSSProperties = {
        position: 'absolute',
        width: width,
        height: height,
        top: y,
        left: x,
    }

    useEffect(() => {
        return () => {
        };
    }, []);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // e.stopPropagation();
        // onNext && onNext(currIndex + 1)
    }

    return (
        <>
            {(currentStep === currIndex) &&<div style={wrapperStyle}>
                <div className={styles.step1}>
                    <img src="/img/guide/xsyd_2.webp" width={width} height={height} alt=""/>
                    <div className={styles.arrow}></div>
                    <div className={`${styles.popover} ${styles.popover_step2}`}>
                        Play with
                        <img className={styles.gold_icon} src="/img/ico_sc.png" alt=""/>
                        <span style={{color: '#2FAF15', fontWeight: 900}}>SWEEPS COIN </span>
                        & redeem your winnings&nbsp;
                        <span style={{color: '#2FAF15', fontWeight: 900}}>for cash.</span>
                        <div style={{color: '#0090FF', textDecoration: 'underline'}}
                             onClick={(e) => e.stopPropagation()}>
                            <a href={confJson.sweepstakes_rules_url} target='_blank'>Sweepstakes Rules</a>
                        </div>
                        <div className={styles.tips}>1SC = 1USD</div>
                        <div className={`${styles.button} ${styles.button_step2}`}>
                            <Button color="#0090FF" style={buttonStyle} onClick={handleClick}>Awesome</Button>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default Step2;